import {
  MENUTYPE_LIST_LOADING,
  GET_MENUTYPE_LIST_ERROR,
  GET_MENUTYPE_LIST,
  GET_MENUTYPE_BY_ID_LOADING,
  GET_MENUTYPE_BY_ID_SUCCESS,
  GET_MENUTYPE_BY_ID_ERROR,
  DELETEING_MENUTYPE,
  DELETE_MENUTYPE,
  DELETE_MENUTYPE_ERROR,
  DELETED_MENUTYPE_LIST_LOADING,
  GET_DELETED_MENUTYPE_LIST,
  GET_DELETED_MENUTYPE_LIST_ERROR,
  RESTORE_MENUTYPE_LIST_LOADING,
  RESTORE_MENUTYPE_LIST,
  RESTORE_MENUTYPE_LIST_ERROR,
  PERMA_DELETEING_MENUTYPE,
  PERMA_DELETE_MENUTYPE,
  PERMA_DELETE_MENUTYPE_ERROR,
} from "./types";

const INITIAL_STATE = {
  data: undefined,
  loading: false,
  error: false,
  dataById: undefined,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MENUTYPE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_MENUTYPE_BY_ID_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETEING_MENUTYPE:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETED_MENUTYPE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case RESTORE_MENUTYPE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case PERMA_DELETEING_MENUTYPE:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case GET_MENUTYPE_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case GET_MENUTYPE_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        dataById: action.payload.data,
        error: false,
      };
    case DELETE_MENUTYPE:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case GET_DELETED_MENUTYPE_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case RESTORE_MENUTYPE_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case PERMA_DELETE_MENUTYPE:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case GET_MENUTYPE_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_MENUTYPE_BY_ID_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case DELETE_MENUTYPE_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_DELETED_MENUTYPE_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case RESTORE_MENUTYPE_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case PERMA_DELETE_MENUTYPE_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };

    default:
      return state;
  }
};

export default reducer;
